import { sendEvent } from '@core/analytics'

export const sendCheckoutPaymentErrorEvent = ({
    message,
    code,
    declineCode = '',
}: {
    message: string
    code: string
    declineCode?: string
}) => {
    sendEvent({
        name: 'checkout_payment_error',
        payload: {
            params__key: ['error_message', 'error_code', 'decline_code'],
            params__str_value: [message, code, declineCode],
        },
    })
}
